import React from 'react';
import {useNavigate} from 'react-router-dom';

import {FormControl, InputGroup} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

const HeaderRow2 = () => {
    const navigate = useNavigate();

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div className="pb-2">
            <InputGroup className="position-relative mb-1" onClick={() => navigate('/search')}>
                <InputGroup.Text id="homeSearch" className="bg-elevate-4 border-0 px-2"><IconFi.FiSearch size={24} className="sw-1 text-white text-opacity-38 flip-h"/></InputGroup.Text>
                <FormControl placeholder="جستجوی میکا مال" aria-label="Search" aria-describedby="homeSearch" className="bg-elevate-4 border-0 ps-0" readOnly/>
            </InputGroup>
        </div>
    )
}

export default HeaderRow2;